import { Money } from "@saas/shared/utils/formatter/money/money";

import { PromoGrantTypeEnum } from "../../@enum/store/promo-grant-type/promo-grant-type.enum";
import { PromoRuleTypeEnum } from "../../@enum/store/promo-rule-type/promo-rule-type.enum";
import { StorePromoRuleInterface } from "../../@interface/store/store-promo-rule/store-promo-rule.interface";
import { getPromoPaymentMethodLabel } from "../get-promo-payment-method-label/get-promo-payment-method-label";

export type GetStorePromoRuleLabelInput = {
  rule?: StorePromoRuleInterface;
  minimumSalesAmount?: Money;
  grantType?: PromoGrantTypeEnum;
};

export type GetStorePromoRuleLabelOutput = string;

export const getStorePromoRuleLabel = ({
  rule,
  minimumSalesAmount,
  grantType,
}: GetStorePromoRuleLabelInput): GetStorePromoRuleLabelOutput => {
  const options =
    rule?.config.paymentMethodOptions?.map((option) =>
      getPromoPaymentMethodLabel(option)
    ) ?? [];
  const lastOption = options[options.length - 1];

  switch (rule?.label) {
    case PromoRuleTypeEnum.MINIMUM_ORDER_QUANTITY:
      return `Minimum Pembelian: ${rule?.config.minimumQuantity} barang`;

    case PromoRuleTypeEnum.MINIMUM_ORDER_SALES_AMOUNT:
      return minimumSalesAmount
        ? `Nominal Pembelian Minimum: ${minimumSalesAmount?.currencyValue}`
        : "";

    case PromoRuleTypeEnum.MINIMUM_PRODUCT_ORDER_QUANTITY:
      return grantType === PromoGrantTypeEnum.PROMO_GRANT_TYPE_ALL
        ? `${rule?.config.masterProduct?.name} ${rule?.config.masterProductVariant?.name}`
        : `Produk Utama: "${rule?.config.masterProductVariant?.name}"`;

    case PromoRuleTypeEnum.PAYMENT_METHOD:
      return options.length > 1
        ? `Pembayaran ${options
            .slice(0, options.length - 1)
            ?.join(", ")} & ${lastOption}`
        : options.length
        ? `Pembayaran ${options[0]}`
        : "";
    default:
      return "";
  }
};

export default getStorePromoRuleLabel;
